import React, { Component } from 'react';
import { multipleValidate, formatValidation } from '../../../../../../../../helpers/functions';
import Modal from '../../../../../../common/component/Modal';
import TourLineContent from '../TourLineContent';
import { TourLineBulk } from '../../../../../../../../models/Tour';
import { Checkbox, List, message } from 'antd';
import moment from "moment";
import Wrapper from '../../../../../../common/component/Wrapper';
import AntSelect, { AntOption } from '../../../../../../common/component/AntSelect';
import { FormWrapperInputComponent } from '../../../../../../common/component/Index';

export default class TourLineBulkCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            validation: [{}],
            tourLineBulk: new TourLineBulk(),
            step: 0,
            dateRange: [],
            selectedTourTicketIds: [],
            tourTicketItemIds: [],
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            this.setTourLineBulk(this.props.dateRange);
        }
    }

    render() {
        const { t, visible,loading } = this.props;
        const { validation, tourLineBulk } = this.state;
        return (
            visible && <Modal className="tour-line-bulk-create"
                              width={ 900 }
                              visible={ visible }
                              title={ `${ t(`action.addMulti`) } ${ t(`item.tour.departure`).toLowerCase() }` }
                              onOk={ this.onSave } okText={ t(`action.save`) }
                              onCancel={ this.props.onCancel } cancelText={ t(`action.cancel`) }
            >
                <TourLineContent
                    loading = {loading}
                    tour={ this.props.tour }
                    tourLine={ tourLineBulk }
                    index={ 0 }
                    withoutSaveBtn={ true }
                    showActiveToggle={ false }
                    hidePrices={ true }
                    hideTickets={ true }
                    showStep={ true }
                    validation={ validation }
                    onChange={ this.onChange }
                    onSelectDateRange={ this.onSelectRange }
                    onSave={ this.onSave }
                    onInitTickets={ this.props.onInitTickets }
                />
                { this.renderTicketCreateSection() }
            </Modal>
        )
    }

    setTourLineBulk(dateRange) {
        const { tourLineBulk } = this.state;
        if (dateRange && dateRange.length) {
            tourLineBulk.fromDate = dateRange[0];
            tourLineBulk.toDate = dateRange[1];
        }
        tourLineBulk.seats = 0;
        tourLineBulk.step = 0
        const selectedTourTickets = this.getInitialSelectedTourTickets();
        this.setState({
            tourLineBulk,
            selectedTourTicketIds: selectedTourTickets.map(ticket => ticket.id),
            tourTicketItemIds: this.getTicketItemIds(selectedTourTickets),
        })
    }

    onChange = (index, fieldName, value) => {
        const tourLineBulk = this.state.tourLineBulk;
        tourLineBulk[fieldName] = value;
        this.setState({ tourLineBulk });
    };

    onSelectRange = (date, index) => {
        const tourLineBulk = this.state.tourLineBulk;
        tourLineBulk.fromDate = date.fullValue[0];
        tourLineBulk.toDate = date.fullValue[1];
        this.setState({ tourLineBulk })
    }

    onSave = () => {
        const { tourLineBulk, tourTicketItemIds } = this.state;
        const selectedTourTickets = this.getSelectedTourTickets();
        tourLineBulk.tourId = this.props.tourId;
        if (this.validate()) {
            return this.props.onSave({
                ...tourLineBulk,
                fromDate: moment(tourLineBulk.fromDate).utc().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
                toDate: moment(tourLineBulk.toDate).utc().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
                selectedTourTickets,
                tourTicketItemIds,
            })
        } else {
            message.error(this.props.t('validation.checkForm'));
        }
    }

    renderTicketCreateSection = () => {
        const { t, tourTickets } = this.props;
        const { selectedTourTicketIds, tourTicketItemIds } = this.state;
        const selectedTourTickets = this.getSelectedTourTickets();
        return (
            <Wrapper className="col-md-12 basic-section mt-3">
                <FormWrapperInputComponent
                    labelTitle={ t(`item.tour.createTicket`) }
                >
                    <AntSelect
                        mode="multiple"
                        showArrow
                        showSearch
                        value={ selectedTourTicketIds }
                        onChange={ this.onChangeTourTickets }
                        style={ { width: '100%' } }
                        filterOption={ this.selectFilterSearch }
                    >
                        { (tourTickets || []).map(ticket => (
                            <AntOption key={ ticket.id } value={ ticket.id }>
                                { ticket.name }
                            </AntOption>
                        )) }
                    </AntSelect>
                </FormWrapperInputComponent>
                { selectedTourTickets.length > 0 &&
                    <FormWrapperInputComponent
                        labelTitle={ t(`item.tour.ticketObjectType`) }
                    >
                        <Wrapper className="tour-ticket-object-type-columns">
                            { selectedTourTickets.map(ticket => (
                                <Wrapper className="tour-ticket-object-type-column" key={ ticket.id }>
                                    <Wrapper className="tour-ticket-object-type-title">{ ticket.name }</Wrapper>
                                    <List
                                        size="small"
                                        dataSource={ ticket.tourTicketItems || [] }
                                        renderItem={ item =>
                                            <List.Item>
                                                <Checkbox
                                                    className="ml-2"
                                                    checked={ tourTicketItemIds.includes(item.id) }
                                                    onChange={ e => this.onChangeTicketItem(item.id, e.target.checked) }
                                                >
                                                    { `${ item?.objectType?.name } - ${ item?.salePrice.toLocaleString() } ${ t(`currency`) }` }
                                                </Checkbox>
                                            </List.Item>
                                        }
                                    />
                                </Wrapper>
                            )) }
                        </Wrapper>
                    </FormWrapperInputComponent>
                }
            </Wrapper>
        )
    }

    getInitialSelectedTourTickets = () => {
        return this.props.initialSelectedTourTickets || [];
    }

    getSelectedTourTickets = () => {
        const { tourTickets } = this.props;
        const { selectedTourTicketIds } = this.state;
        return (tourTickets || []).filter(ticket => selectedTourTicketIds.includes(ticket.id));
    }

    getTicketItemIds = (tickets = []) => {
        return tickets.reduce((ids, ticket) => ids.concat((ticket.tourTicketItems || []).map(item => item.id)), []);
    }

    onChangeTourTickets = (selectedTourTicketIds = []) => {
        const selectedTourTickets = (this.props.tourTickets || []).filter(ticket => selectedTourTicketIds.includes(ticket.id));
        this.setState({
            selectedTourTicketIds,
            tourTicketItemIds: this.getTicketItemIds(selectedTourTickets),
        });
    }

    onChangeTicketItem = (id, checked) => {
        const currentIds = this.state.tourTicketItemIds || [];
        const tourTicketItemIds = checked
            ? (currentIds.includes(id) ? currentIds : [...currentIds, id])
            : currentIds.filter(itemId => itemId !== id);
        this.setState({ tourTicketItemIds });
    }

    selectFilterSearch = (input, option) => {
        const optionText = String(option.props.children || '').toLowerCase();
        const inputText = input.toLowerCase();
        return optionText.indexOf(inputText) >= 0;
    }

    validate = () => {
        const { tourLineBulk } = this.state;
        const { t } = this.props;
        let validate = {
            required: {
                fromDate: formatValidation(t('validation.statusCode.code.1'), t(`item.tour.departureDate`)),
                seats: formatValidation(t('validation.statusCode.code.1'), t(`item.tour.seats`)),
                step: formatValidation(t('validation.statusCode.code.1'), t(`item.tour.step`)),
            },
        };
        const result = multipleValidate(tourLineBulk, validate, {});
        this.setState({ validation: result });
        return Object.keys(result) <= 0;
    }

}

TourLineBulkCreate.defaultProps = {
    tourId: undefined,
    tourTickets: [],
    initialSelectedTourTickets: [],
    onChange: (fieldName, value) => {
    },
    onSelectDate: (date, index) => {
    },
    onSave: (tourLineBulk) => {
    },
    dateRange: [],
}


